import { AnswerType } from '@bybeam/platform-types';

export const EDUCATION_LEVELS = [
  { label: 'Some high school, no diploma', value: 'someHighSchoolNoDiploma' },
  {
    label: 'High school graduate, diploma or equivalent (e.g. GED)',
    value: 'highSchoolGraduateDiplomaOrEquivalent',
  },
  { label: 'Some college, no degree', value: 'someCollegeNoDegree' },
  { label: 'Trade school or vocational training', value: 'tradeSchoolOrVocationalTraining' },
  { label: "Associate's degree", value: 'associatesDegree' },
  { label: "Bachelor's degree", value: 'bachelorsDegree' },
  { label: "Master's degree or professional degree", value: 'mastersDegreeOrProfessionalDegree' },
  { label: 'Doctoral degree', value: 'doctoralDegree' },
  { label: 'None of the above', value: 'other' },
];

export const DEBT_LEVELS = [
  { label: 'Under $10,000', value: 'under10k' },
  { label: '$10,000 to $25,000', value: '10kTo25k' },
  { label: '$25,001 to $50,000', value: '25001To50k' },
  { label: '$50,000-$100,000', value: '50kTo100k' },
  { label: 'Over $100,000', value: 'over100k' },
  { label: 'Over $200,000', value: 'over200k' },
  { label: 'None / Not Applicable', value: AnswerType.None },
];

export const ETHNICITIES = [
  {
    label: 'African / Black American',
    value: 'africanAndOrBlackAmerican',
  },
  {
    label: 'North American Native',
    value: 'northAmericanNative',
  },
  {
    label: 'Asian American',
    value: 'asianAmerican',
  },
  {
    label: 'Chicano / Hispanic / Latino American',
    value: 'chicanoAndOrHispanicAndOrLatinoAmerican',
  },
  {
    label: 'Native Hawaiian or Other Pacific Islander',
    value: 'nativeHawaiianOrOtherPacificIslander',
  },
  { label: 'White/Caucasian', value: 'whiteOrCaucasian' },
  { label: 'Not specified in list', value: 'other' },
  { label: 'Prefer not to say', value: AnswerType.Decline },
];

export const LANGUAGES = [
  {
    label: 'English',
    value: 'english',
  },
  {
    label: 'Spanish',
    value: 'spanish',
  },
  {
    label: 'Chinese',
    value: 'chinese',
  },
  {
    label: 'Cantonese, Mandarin, or other dialect',
    value: 'cantoneseOrMandarinOrOtherDialect',
  },
  {
    label: 'Vietnamese',
    value: 'vietnamese',
  },
  { label: 'Korean', value: 'korean' },
  { label: 'Hindi', value: 'hindi' },
  { label: 'Other', value: 'other' },
];

export const SECTORS = [
  { label: 'Arts and Culture', value: 'artsAndCulture' },
  { label: 'Healthcare', value: 'healthcare' },
  { label: 'Information Technology', value: 'informationTechnology' },
  { label: 'Real Estate', value: 'realEstate' },
  { label: 'Retail (including Food & Beverage)', value: 'retailIncludingFoodAndBeverage' },
  { label: 'Education', value: 'education' },
  { label: 'Government', value: 'government' },
  { label: 'Professional Services', value: 'professionalServices' },
  { label: 'Non-profit', value: 'nonProfit' },
  { label: 'Other', value: 'other' },
  { label: 'Unemployed', value: 'unemployed' },
];

export const MARITAL_STATUSES = [
  { label: 'Single, never married', value: 'singleNeverMarried' },
  { label: 'Married', value: 'married' },
  { label: 'Divorced', value: 'divorced' },
  { label: 'Separated', value: 'separated' },
  { label: 'Widowed', value: 'widowed' },
];

export const TRANSPORTATION_MODES = [
  { label: 'Personal Vehicle', value: 'personalVehicle' },
  { label: 'Bus/Public Transit', value: 'busOrPublicTransit' },
  { label: 'Taxi/Rideshare', value: 'taxiOrRideshare' },
  { label: 'Bike', value: 'bike' },
  { label: 'Walk', value: 'walk' },
  { label: 'Remote/Work From Home', value: 'remoteOrWorkFromHome' },
];

export const INCOME_LEVELS = [
  { label: 'Less than $15,000', value: 'lessThan15k' },
  { label: '$15,001 - $24,000', value: '15kTo24k' },
  { label: '$24,001 - $34,000', value: '24kTo34k' },
  { label: '$34,001 - $54,000', value: '34kTo54k' },
  { label: '$54,001 - $75,000', value: '54kTo75k' },
  { label: '$75,001 - $100,000', value: '75kTo100k' },
  { label: '$100,001 - $150,000', value: '100kTo150k' },
  { label: '$150,001 - $200,000', value: '150kTo200k' },
  { label: 'More than $200,000', value: 'moreThan200k' },
];

export const ASSET_TYPES = [
  { label: 'Stocks or Other Securities', value: 'stocksOrOtherSecurities' },
  { label: 'Bonds, Mutual Funds, etc.', value: 'bondsMutualFundsEtc' },
  { label: 'Savings Account', value: 'savingsAccount' },
  { label: 'Real Estate', value: 'realEstate' },
  { label: 'Life Insurance', value: 'lifeInsurance' },
  { label: 'Family Trust Fund', value: 'familyTrustFund' },
  { label: 'Cryptocurrency', value: 'cryptocurrency' },
  { label: 'Art', value: 'art' },
  { label: 'Other', value: 'other' },
  { label: 'None of the above', value: 'n/a' },
];

export const CREDIT_RANGES = [
  { label: 'Poor (300-579)', value: 'poor300To579' },
  { label: 'Fair (580-669)', value: 'fair580To669' },
  { label: 'Good (670-739)', value: 'good670To739' },
  { label: 'Very Good (740-799)', value: 'veryGood740To799' },
  { label: 'Exceptional (800-850)', value: 'exceptional800To850' },
];

export const BUSINESS_REASONS = [
  { label: 'Better Pay', value: 'betterPay' },
  { label: 'Unemployed', value: 'unemployed' },
  { label: 'Lost Job Due To Pandemic', value: 'lostJobDueToPandemic' },
  { label: 'Social Impact', value: 'socialImpact' },
  { label: 'Identified a Niche/Opportunity', value: 'identifiedANicheOrOpportunity' },
  { label: 'To Be My Own Boss', value: 'toBeMyOwnBoss' },
  { label: 'Remote Work', value: 'remoteWork' },
  { label: 'Flexibility/Schedule', value: 'flexibilityOrSchedule' },
  { label: 'Other', value: 'other' },
];

export const LEGAL_STRUCTURES = [
  { label: 'Sole Proprietor', value: 'soleProprietor' },
  { label: 'Partnership', value: 'partnership' },
  { label: 'LLC - Limited Liability Corporation', value: 'limitedLiabilityCompany' },
  { label: 'LP - Limited Partnership', value: 'limitedPartnership' },
  { label: 'C-Corporation', value: 'cCorporation' },
  { label: 'S-Corporation', value: 'sCorporation' },
  { label: 'Non-Profit - 501(c)(3)', value: 'nonProfit501C3' },
  { label: 'Other', value: 'other' },
  { label: "I'm not sure", value: 'imNotSure' },
];

export const INDUSTRIES = [
  {
    label: 'Apparel & Accessories (Jewelry Making, Screen printing, etc.)',
    value: 'apparelAndAccessories',
  },
  { label: 'Manufacturing', value: 'manufacturing' },
  { label: 'Software Development', value: 'softwareDevelopment' },
  {
    label:
      'Personal Improvement Services (Hair & Nail Salons, Massage Therapy, Life Coaching, etc.)',
    value: 'personalImprovementServices',
  },
  { label: 'Social Services', value: 'socialServices' },
  { label: 'Education', value: 'education' },
  { label: 'Government', value: 'government' },
  { label: 'Food & Beverage Retail', value: 'foodAndBeverageRetail' },
  {
    label: 'Printing and Related Support Activities',
    value: 'printingAndRelatedSupportActivities',
  },
  { label: 'Construction, HVAC & Electrical', value: 'constructionHVACAndElectrical' },
  {
    label: 'Real Estate & Real Estate Property Management',
    value: 'realEstateAndRealEstatePropertyManagement',
  },
  { label: 'Mental Health Counseling', value: 'mentalHealthCounseling' },
  { label: 'Marketing and/or social media', value: 'marketingAndOrSocialMedia' },
  { label: 'Medical (Home Care, Nursing, Chiropractic, Dental, etc.)', value: 'medical' },
  { label: 'Consultant', value: 'consultant' },
  { label: 'Professional Speaker', value: 'professionalSpeaker' },
  { label: 'Accommodation (Hotel, Travel Agents, Lyft, Uber, etc.)', value: 'accommodation' },
  { label: 'Arts (Creation, Education, Entertainment)', value: 'arts' },
  { label: 'Farming', value: 'farming' },
  { label: 'Textiles & Leather', value: 'textilesAndLeather' },
  {
    label: 'Employee Support Services (Virtual Assistants, Staffing Agency, etc.)',
    value: 'employeeSupportServices',
  },
  {
    label: 'Transportation, Trucking, and Freight Movement',
    value: 'transportationTruckingAndFreightMovement',
  },
  { label: 'Media (Publishing, Film, Podcasts, etc.)', value: 'media' },
  { label: 'Lawn Care (gardening, landscaping, mowing, etc.)', value: 'lawnCare' },
  { label: 'Commercial & Residential Cleaning', value: 'commercialAndResidentialCleaning' },
  { label: 'Finance/Investing', value: 'financeInvesting' },
  { label: 'Accounting', value: 'accounting' },
  { label: 'Legal', value: 'legal' },
  { label: 'Other (open ended)', value: 'other' },
];

export const RESOURCES = [
  { label: 'Digital Skills/E-Commerce Training', value: 'digitalSkillsECommerceTraining' },
  { label: 'Affordable Commercial Space', value: 'affordableCommercialSpace' },
  { label: 'Manufacturing', value: 'manufacturing' },
  { label: 'Supplies for Fabrication of Products', value: 'suppliesForFabricationOfProducts' },
  {
    label: 'Well-Trained Employees or Job Candidates',
    value: 'wellTrainedEmployeesOrJobCandidates',
  },
  { label: 'Production Space', value: 'productionSpace' },
  {
    label: 'Professional Services (i.e., Accounting, Legal, Marketing)',
    value: 'professionalServices',
  },
  { label: 'Support with developing a business plan', value: 'supportWithDevelopingABusinessPlan' },
  { label: 'Other (open ended)', value: 'other' },
  { label: 'None of the above', value: AnswerType.None },
];

export const MARKETING_MATERIALS = [
  { label: 'Logo', value: 'logo' },
  { label: 'Branding guide', value: 'brandingGuide' },
  { label: 'Website', value: 'website' },
  { label: 'Business cards', value: 'businessCards' },
  {
    label: 'Banners and other physical, promotional materials',
    value: 'physicalPromotionalMaterials',
  },
  { label: 'Social media templates and/or graphics', value: 'socialMediaTemplatesGraphics' },
  { label: 'None', value: 'none' },
  { label: 'Other', value: 'other' },
];

export const SOCIAL_MEDIA_PLATFORMS = [
  { label: 'Facebook', value: 'facebook' },
  { label: 'Instagram', value: 'instagram' },
  { label: 'X (Formerly Twitter)', value: 'xFormerlyTwitter' },
  { label: 'LinkedIn', value: 'linkedIn' },
  { label: 'Threads', value: 'threads' },
  { label: 'Other', value: 'other' },
  { label: 'None', value: 'none' },
];

export const PERCENTAGE_RANGES = [
  { label: '0% - 25%', value: '0To25' },
  { label: '25% - 50%', value: '25To50' },
  { label: '50% - 75%', value: '50To75' },
  { label: '75% - 100%', value: '75To100' },
];

export const REVENUE_RANGES = [
  { label: 'Less than $28,000', value: 'lessThan28k' },
  { label: '$28,001 - $55,000', value: '28kTo55k' },
  { label: '$55,001 - $110,000', value: '55kTo110k' },
  { label: '$110,001 - $220,000', value: '110kTo220k' },
  { label: '$220,001 - $440,000', value: '220kTo440k' },
  { label: '$440,001 - $880,000', value: '440kTo880k' },
  { label: '$880,001 - $1M', value: '88kTo1M' },
  { label: '$1M - $2M', value: '1mTo2m' },
  { label: '$2M - $5M', value: '2mTo5m' },
  { label: '$5M - $10M', value: '5mTo10m' },
  { label: '$10M+', value: '10mPlus' },
];

export const CITY_DEPARTMENTS = [
  { label: 'Health Department - Food permit', value: 'healthDeptFoodPermit' },
  { label: "Food handler's permit", value: 'foodHandlersPermit' },
  { label: 'Regulated Industries', value: 'regulatedIndustries' },
  { label: 'Planning - Zoning Clearance Request', value: 'planningZoningClearanceRequest' },
  {
    label: 'Permitting - Certificate of Occupancy, Building Permits, etc.',
    value: 'permittingCOBuildingPermits',
  },
  { label: 'KCPD - KCMO Police Clearance', value: 'kcpdKcmoPoliceClearance' },
  { label: 'KCFD - Fire Marshall Inspection (Fire)', value: 'kcfdFireMarshallInspection' },
  { label: 'Procurement - Vendor Registration', value: 'procurementVendorRegistration' },
  { label: 'None', value: AnswerType.None },
  { label: 'Other', value: 'other' },
];

export const FUNDING_CHALLENGES = [
  {
    label: 'Financial State of Business Due to Pandemic Losses',
    value: 'financialStatePandemicLosses',
  },
  { label: 'Personal Credit/Low Credit Score', value: 'personalCreditLowCreditScore' },
  {
    label: 'Lack of existing business relationship with banker',
    value: 'lackOfBusinessRelationshipWithBanker',
  },
  {
    label: 'Did not qualify for loans due to size of business/lack of employees',
    value: 'didNotQualifyDueToSize',
  },
  { label: 'Insufficient Personal Guarantees', value: 'insufficientPersonalGuarantees' },
  { label: 'No Collateral', value: 'noCollateral' },
  { label: 'Other', value: 'other' },
  { label: "I haven't experienced any issues", value: AnswerType.None },
  { label: 'Not applicable- have not applied for funding', value: 'notApplicableNotApplied' },
  { label: 'Don’t know where to start in accessing capital', value: 'dontKnowWhereToStart' },
  { label: 'Lack of resources to apply', value: 'lackOfResourcesToApply' },
];

export const COVID_RELIEF_PROGRAMS = [
  { label: 'PPP - Paycheck Protection Program', value: 'ppp' },
  { label: 'EIDL - Economic Injury Disaster Loan', value: 'eidl' },
  { label: 'RRF - Restaurant Revitalization Fund', value: 'rrf' },
  { label: 'SVOG - Shuttered Venue Operators Grant', value: 'svog' },
  { label: 'Other', value: 'other' },
  { label: 'None', value: AnswerType.None },
];

export const CAPITAL_RAISING_EFFORTS = [
  { label: 'Venture Capital Funding', value: 'ventureCapitalFunding' },
  { label: 'Equity Financing', value: 'equityFinancing' },
  { label: 'Crowdfunding (i.e., Kickstarter or Kiva)', value: 'crowdfunding' },
  { label: 'Angel Investing', value: 'angelInvesting' },
  { label: 'Traditional Bank Loan', value: 'traditionalBankLoan' },
  { label: 'Credit Union Loan', value: 'creditUnionLoan' },
  {
    label: 'CDFI Loan Program (i.e., Alt Cap, Dream Spring, Justine Peterson)',
    value: 'cdfiLoanProgram',
  },
  { label: "I'm not raising any capital presently", value: AnswerType.None },
];

export const POS_SYSTEMS = [
  { label: 'Payment Apps - i.e., CashApp, Venmo, PayPal', value: 'paymentApps' },
  { label: 'Tablet/Terminal - (Square, Clover, QuickBooks, Etc.)', value: 'tabletTerminal' },
  { label: 'Legacy/Traditional (In-House Computer & Register Till)', value: 'legacyTraditional' },
  { label: 'Invoices clients (Accounts Receivable)', value: 'invoicesClients' },
];

export const WORKSPACES = [
  { label: 'From my home', value: 'fromMyHome' },
  { label: "Maker's space", value: 'makersSpace' },
  { label: 'Commercial Production Space', value: 'commercialProductionSpace' },
  { label: 'Commercial Retail Space', value: 'commercialRetailSpace' },
  { label: 'Shared Kitchen / Commissary Kitchen / Ghost Kitchen', value: 'sharedKitchen' },
  { label: 'Co-Working Space - i.e., Plexpod, WeWork, Spark', value: 'coWorkingSpace' },
  { label: 'Commercial Office Space', value: 'commercialOfficeSpace' },
  { label: 'Food Truck (mobile)', value: 'foodTruck' },
  { label: 'Other (open ended)', value: 'other' },
];

export const BENEFITS = [
  { label: 'Healthcare', value: 'healthcare' },
  { label: 'Dental', value: 'dental' },
  { label: 'Vision', value: 'vision' },
  { label: 'Childcare', value: 'childcare' },
  { label: 'Other', value: 'other' },
];

export const ROLES = [
  { label: 'Administrative', value: 'administrative' },
  { label: 'Marketing', value: 'marketing' },
  { label: 'Legal', value: 'legal' },
  { label: 'Accounting', value: 'accounting' },
  { label: 'HR Personnel', value: 'hrPersonnel' },
  { label: 'IT/Technical Support', value: 'itTechnicalSupport' },
  { label: 'Program Management', value: 'programManagement' },
  { label: 'Sales', value: 'sales' },
  { label: 'Contractor', value: 'contractor' },
  { label: 'Engineers', value: 'engineers' },
  { label: 'Technicians', value: 'technicians' },
  { label: 'Cashier', value: 'cashier' },
  { label: 'Management Support (C-Suite)', value: 'managementSupport' },
  { label: 'Data Entry', value: 'dataEntry' },
  { label: 'Customer Service Representative', value: 'customerServiceRepresentative' },
  { label: 'Software Developer', value: 'softwareDeveloper' },
  { label: 'Food Prep/Cook', value: 'foodPrepCook' },
  { label: 'Other', value: 'other' },
];

export const CERTIFICATIONS = [
  { label: 'MBE - Minority Business Enterprise', value: 'mbe' },
  { label: 'DBE - Disadvantaged Business Enterprise', value: 'dbe' },
  { label: 'WBE - Woman Business Enterprise', value: 'wbe' },
  { label: 'SLBE - Small Local Business Enterprise', value: 'slbe' },
  { label: 'SBE - Small Business Enterprise', value: 'sbe' },
  { label: 'Other', value: 'other' },
  { label: 'None', value: 'none' },
];

export const DEVICES = [
  { label: 'Cell phone', value: 'cellPhone' },
  { label: 'Laptop', value: 'laptop' },
  { label: 'Desktop Computer', value: 'desktopComputer' },
  { label: 'Tablet', value: 'tablet' },
];

export const TECH_TOPICS = [
  { label: 'Laptop', value: 'laptop' },
  { label: 'Wi-Fi Hotspot', value: 'wifiHotspot' },
  { label: 'Cell phone', value: 'cellPhone' },
  { label: 'Desktop computer', value: 'desktopComputer' },
];
